import { useNavigateAndScroll } from "../../../../hooks/useNavigateAndScroll";

export const HeroSection = () => {
  const navigateAndScroll = useNavigateAndScroll();

  return (
    <section
      className="light-section"
      style={{ minHeight: "calc(100svh - 5rem)" }}
    >
      <div className="columna">
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Mas valor para tus decisiones</p>
        </span>
        <p className="section-title">
          <span>
            Convertí <br />
            datos en decisiones <br />
            <span style={{ color: "var(--red-highlight)" }}>estratégicas</span>
          </span>
        </p>

        <p className="section-subtitle">
          Anticipá lo que necesita el mercado, mejorá tus operaciones
          <br /> y aumentá tu{" "}
          <span className="underscore">
            rentabilidad
            <img
              alt="subrayado"
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado1-20.png`}
            />
          </span>{" "}
          con estrategias basadas
          <br />
          en inteligencia de negocios.
        </p>
        <span className="horizontal gap-16" style={{ marginTop: 50 }}>
          <button
            className="boton-generico boton-rojo"
            onClick={() => navigateAndScroll("/business-intelligence", "top")}
          >
            Inteligencia de negocios
          </button>
          <button
            className="boton-generico boton-azul"
            onClick={() => navigateAndScroll("/", "brocoly")}
          >
            Inteligencia del cliente
          </button>
        </span>
      </div>
      <img
        className="img-tableros"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/tablero1.png`}
        alt="tableros"
      />
    </section>
  );
};
